import React$1 from 'react';

const Signet = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "406",
  height: "406",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React$1.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M202.722 399.806c108.121 0 196.084-87.963 196.084-196.084 0-108.122-87.963-196.085-196.084-196.085C94.6 7.637 6.637 95.6 6.637 203.722c0 108.12 87.964 196.084 196.085 196.084",
  stroke: "#FF005F",
  strokeWidth: "3.914"
}), /*#__PURE__*/React$1.createElement("path", {
  d: "M239.386 159.43l-22.248 62.295h44.242l-21.51-62.295h-.484zm-77.048 123.65l59.32-158.67a3.186 3.186 0 012.994-2.06h30.688a3.165 3.165 0 013.052 2.348l58.251 158.246c.203.574.249.906.249 1.259a3.147 3.147 0 01-3.144 3.15H286.4c-1.383 0-2.577-.913-3.014-2.14l-12.19-35.664H207.34l-12.574 35.424a3.125 3.125 0 01-3.027 2.38h-26.442a3.152 3.152 0 01-3.15-3.15c0-.411.059-.776.19-1.122zM134.111 287.35h-23.487a2.81 2.81 0 01-2.805-2.811v-84.126H91.357a2.81 2.81 0 01-2.805-2.811v-20.487a2.81 2.81 0 012.805-2.81h16.462v-19.242c0-25.307 12.25-34.973 34.334-34.973 6.894 0 11.089.124 13.919.28a2.81 2.81 0 012.648 2.805v20.565a2.812 2.812 0 01-2.811 2.811h-7.716c-11.042 0-11.27 3.45-11.27 13.573v14.18H156.6a2.811 2.811 0 012.812 2.811v20.487a2.811 2.811 0 01-2.812 2.81h-19.678v84.127a2.811 2.811 0 01-2.81 2.81",
  fill: "#FF005F"
})));

export default Signet;
